import {ISoundConfig} from '@gongxigames/framework/slot/types/ISoundConfig';
import {SoundsProperties} from '@gongxigames/framework/slot/types/SoundProperties';

export interface IAudioConfig {
    soundConfig: ISoundConfig;
    musicConfig: ISoundConfig;
    soundType: string;
    properties?: SoundsProperties;
}
